import { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { toast } from "react-toastify";
import { ContentBox, ContentPage, NoResults, Pagination } from "@ficatranquilo/contabilidade.com-ui";
import useService from "@hooks/useService";
import { usePageHeader } from "@components/ow";
import { ProjectCard, ProjectCardsSkeleton, ProjectGrid } from "../../Common/ProjectCards";

// Página da API por requisição (o padrão do back). O prestador está em poucos
// projetos; a paginação só aparece quando passa de uma página.
const PAGE_SIZE = 50;

const BREADCRUMB = [{ page: "Projetos", route: "/e/projects" }];

const Pager = styled.div`
  margin-top: 20px;
`;

export default function ProjectsEmployee() {
  const projectService = useService("projects");
  const [loading, setLoading] = useState(true);
  const [pageIndex, setPageIndex] = useState(0);
  const [data, setData] = useState({ list: [], totalRegisters: 0, totalPages: 1 });
  // Só a resposta da última requisição vale (troca de página rápida)
  const lastRequest = useRef(0);

  usePageHeader({ title: "Projetos", breadcrumb: BREADCRUMB });

  useEffect(() => {
    fetchProjects();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageIndex]);

  async function fetchProjects() {
    const request = ++lastRequest.current;
    setLoading(true);
    try {
      // O back devolve os projetos de que o prestador é membro, na empresa ativa
      const result = await projectService.list(`page=${pageIndex + 1}&limit=${PAGE_SIZE}`);
      if (request !== lastRequest.current) return;
      const list = result?.data?.list || [];
      setData({
        list,
        totalRegisters: result?.data?.totalRegisters ?? list.length,
        totalPages: result?.data?.totalPages || 1,
      });
    } catch (error) {
      if (request !== lastRequest.current) return;
      console.error(error);
      toast.error(error?.response?.data?.msg || "Erro ao carregar os projetos");
      setData({ list: [], totalRegisters: 0, totalPages: 1 });
    }
    setLoading(false);
  }

  let content;
  if (loading) {
    content = <ProjectCardsSkeleton />;
  } else if (data.list.length === 0) {
    content = <NoResults notResultText="Nenhum projeto por aqui" />;
  } else {
    content = (
      <>
        <ProjectGrid>
          {data.list.map((project) => (
            <ProjectCard key={project.id} project={project} route={`/e/projects/${project.id}`} showErp={false} />
          ))}
        </ProjectGrid>
        {data.totalPages > 1 ? (
          <Pager>
            <Pagination
              $pageIndex={pageIndex}
              $pageCount={data.totalPages}
              $totalRecords={data.totalRegisters}
              $pageSize={PAGE_SIZE}
              onChangePage={setPageIndex}
            />
          </Pager>
        ) : null}
      </>
    );
  }

  return (
    <ContentPage>
      <ContentBox>{content}</ContentBox>
    </ContentPage>
  );
}
